
export const environment = {
    env: 'test',
    production: false,
    membershipModuleName: 'buildings.frontend.membership',
    dossierModuleName: 'buildings.frontend.dossier',
    sharedModuleName: 'buildings.frontend.shared',
    applicationName: 'buildings.frontend',
    buildingsBackendMembershipHost: 'buildings.tanocom.it',
    buildingsBackendDossierHost: 'buildings.tanocom.it',
    buildingsBackendMembershipAddress: 'https://test-api-membership.buildings.tanocom.it',
    buildingsBackendDossierAddress: 'https://test-api-dossier.buildings.tanocom.it',
    permissionPolicy: 'enabled',
    buildingsMembershipclientAccessUuidTokenName: 'client-token',
    buildingsMembershipClientAccessUuidToken: '0717d581-96fe-419c-a6f2-42ce13bc8fd4',
    buildingsMembershipEncryptSalt: "2jR04P3M9cBtYGywBeaWag==",
    buildingsDossierclientAccessUuidTokenName: 'client-token',
    buildingsDossierClientAccessUuidToken: 'cb427aee-a2d3-465e-b540-44e55e9609c0',
    buildingsDossierEncryptSalt: "vZ8nF6xW4hD1qKjM3rTcEw==",
    authenticationTokenCookieName: 'authentication-token',
    refreshTokenCookieName: 'refresh-token',
    // sessionUUIDCookieName: 'session-uuid-token',
    authenticationTypeCookieName: 'authentication-type',
    authenticationTypeCookieValue_local: 'local',
    authenticationTypeCookieValue_session: 'session',
    clientFingerprintHeaderName: 'client-fingerprint',
    activeLegalEntityEncryptedIdHeaderName: 'active-legal-entity-id',
    userRolesHeaderName: 'user-roles',
    restcountriesApiUrl: 'https://restcountries.com/',
    restcountriesApiToken: 'rc_live_34a647d96d0e4080b60fcc5b98c01d69',
    restcountriesApiEuropePath: 'countries/v5',
    surveyorSupplierUserId: '3',
    surveyorSupplierLegalEntityId: '2',
    customerCareUserId: '1',
    customerCareLegalEntityId: '1',
    systemAdministratorUserId: '1',
    systemAdministratorLegalEntityId: '1',
    entityDocumentStatusPollIntervalMs: 5000
    // port_number: process.env["BUILDINGS_MEMBERSHIP_PORT"] || 4200
    //buildingsBackendMembershipAddress: ('https://localhost:' + (process.env["PORT"] || 4200) + '/buildingsBackendMembership'),
    // winoMembershipClient_uuid: '0717d581-96fe-419c-a6f2-42ce13bc8fd4',
    // winoLibraryClient_uuid: 'c90b67dc-d554-11ed-afa1-0242ac120002',
    // winoPublishingClient_uuid: '859c338c-d554-11ed-afa1-0242ac120002',
    // authenticationAuthTokenCookieName: 'winoAuthToken',
    // authenticationRefreshTokenCookieName: 'winoRefreshToken',
};